import React, { Component } from "react";
import { observer } from "mobx-react";
import Bscroll from "better-scroll";
import { AllTag, Allqustion } from "../../static/js/http";
import "./index.css";

import { ListView } from "antd-mobile";
import { withRouter } from "react-router-dom";
import TagQuestions from "../TagQuestions";
import Modal from "../Modal";

@observer
class Mainstructure extends Component {
  constructor(props) {
    super(props);
    const ds = new ListView.DataSource({
      rowHasChanged: (r1, r2) => r1 !== r2,
    });
    this.state = {
      width: "120%",
      tabs: [{ name: "全部", id: "all" }],
      Tagid: "all",
      dataArr: [],
      page: 0, //页码
      size: 10, // 每页条数
      totalPage: "", //总页数
      totalElements: "",
      dataSource: ds, //长列表加载数据源
      isLoading: true, //是否加载中
      isHasMore: false, //是否还有更多数据
      refreshing: false,
      scrTop: 0,
      contHeight: 0,
      newLoading: false,
      showModal: false,
      detailId: "",
    };
  }
  getAllList() {
    this.setState({
      newLoading: true,
    });
    let params = {
      page: this.state.page,
      size: this.state.size,
      isAnswered: true,
      isHot: true,
      type: 1,
    };
    if (this.state.Tagid !== "all") {
      params["tagId"] = this.state.Tagid;
    }
    Allqustion(params)
      .then((res) => {
        if (res.msg === "success") {
          let data = res.data;
          if (data.length !== 0) {
            let newData = data.pageData.filter(
              (item) => item.storeQuestionEntity.isShow
            );
            this.setState(
              {
                ...this.state,
                dataSource: this.state.dataSource.cloneWithRows(newData),
                page: this.state.page + 1,
                totalPage: data.totalPages,
                totalElements: data.totalElements,
                dataArr: newData || [],
                isLoading: false,
                newLoading: false,
              },
              () => {
                this.getContentHeight();
              }
            );
          }
        }
      })
      .catch((err) => {
        this.setState({
          isLoading: false,
          newLoading: false,
        });
      });
  }
  componentDidMount() {
    new Bscroll(".TagTitleWrapper", {
      scrollX: true,
      scrollY: false,
    });
    this.getAllTag();
    this.getAllList();
    let that = this;
    // 在用户点击其他地方时，关闭弹窗
    window.onclick = function (event) {
      let modal = document.getElementById("myModal");
      if (event.target === modal && that.state.showModal) {
        modal.style.display = "none";
        that.setState({
          showModal: false,
        });
      }
    };
  }
  // 初始化获取元素高度
  getContentHeight() {
    let contHeight = document.querySelector(".am-list-view-scrollview-content");
    if (contHeight) {
      this.setState({ contHeight: contHeight.offsetHeight });
    }
  }
  // 去搜索页面
  goSearch() {
    this.props.history.push("/search");
  }
  // 获取所有标签
  getAllTag() {
    AllTag()
      .then((res) => {
        if (res.msg === "success") {
          if (res.data.length !== 0) {
            sessionStorage.setItem("tags", JSON.stringify(res.data));
            this.setState({ tabs: [...this.state.tabs, ...res.data] }, () => {
              this.size();
            });
          }
        }
      })
      .catch((err) => {});
  }
  // 获取ul 的宽度
  size() {
    let lin = 0;
    let len = [...this.state.tabs];

    len.map((item) => (lin += item.name.length));
    let lastlen = len.length * 45 + lin * 10;
    this.setState({ width: `${lastlen > 375 ? lastlen : 500}px` });
  }
  // 获取当前TagId
  getCurrentId(id) {
    this.setState({ Tagid: id, page: 0, dataArr: [] }, () => {
      this.getMoreList();
    });
  }
  getMoreList() {
    let data = {
      page: this.state.page,
      size: this.state.size,
      isAnswered: true,
      isHot: true,
      type: 1,
    };
    if (this.state.Tagid !== "all") {
      data["tagId"] = this.state.Tagid;
    }
    this.setState({
      newLoading: true,
    });
    Allqustion(data)
      .then((res) => {
        if (res.msg === "success") {
          let data = this.state.dataArr.concat(res.data.pageData);
          this.setState(
            {
              ...this.state,
              dataSource: this.state.dataSource.cloneWithRows(data),
              page: this.state.page + 1,
              totalPage: res.data.totalPages,
              totalElements: res.data.totalElements,
              dataArr: data,
              isLoading: false,
              newLoading: false,
            },
            () => {
              this.getContentHeight();
            }
          );
        }
      })
      .catch((err) => {
        this.setState({
          isLoading: false,
          newLoading: false,
        });
      });
  }
  // 滑动时触发
  onEndReached = (event) => {
    if (this.state.page + 1 <= this.state.totalPage) {
      if (this.state.totalElements - this.state.dataArr.length >= 1) {
        setTimeout(() => {
          this.setState({
            ...this.state,
            refreshing: true,
            isLoading: true,
          });
          this.getMoreList();
        }, 1000);
      } else {
        this.setState({
          ...this.state,
          refreshing: true,
          isLoading: false,
          hasMore: false,
        });
      }
    } else {
      this.setState({
        ...this.state,
        refreshing: true,
        isLoading: true,
        hasMore: false,
      });
    }
  };
  changeShowId(rowData) {
    this.setState({
      selectData: rowData,
      showModal: true,
      detailId: rowData.storeQuestionEntity && rowData.storeQuestionEntity.id,
    });
  }
  changgeScrollTop(e) {
    if (e.target.clientHeight > this.state.contHeight) {
      let contDom = document.querySelector(".article-body");
      if (!contDom) {
        e.target.scrollTop = 0;
      }
    }
  }
  close() {
    this.setState(
      {
        selectData: {},
        showModal: false,
        page: 0,
      },
      () => {
        this.getAllList();
      }
    );
  }
  render() {
    const row = (rowData, sectionID, rowID) => {
      // 这里rowData,就是上面方法cloneWithRows的数组遍历的单条数据了，直接用就行
      return (
        <TagQuestions
          rowData={rowData}
          sectionID={sectionID}
          rowID={rowID}
          changeShowId={() => this.changeShowId(rowData)}
        />
      );
    };
    const Loading = () => {
      return (
        <div className="loading">
          <span></span>
          <p>正在加载...</p>
        </div>
      );
    };
    return (
      <div className="Mainstructure">
        <div className="Mainstructure_title"></div>
        <div className="Mainstructure_content">
          <div className="Mainstructure_content_title">
            <div className="Mainstructure_title2_l"></div>
            <div className="Mainstructure_title2_c">经典问答</div>
            <div
              onClick={() => {
                this.goSearch();
              }}
              className="Mainstructure_title2_r"
            >
              搜索
            </div>
          </div>
          <div className="Mainstructure_content_b">
            <div className="Mainstructure_content_b_bg">
              <div className="TagTitleWrapper">
                <ul
                  className="TagTitleContent"
                  style={{ width: `${this.state.width}` }}
                >
                  {this.state.tabs.map((item, index) => (
                    <li
                      onTouchEnd={() => this.getCurrentId(item.id)}
                      key={index + "tab"}
                      className={
                        this.state.Tagid === "all" && item.id === "all"
                          ? "Underline activeColor"
                          : this.state.Tagid === item.id
                          ? "Underline"
                          : ""
                      }
                    >
                      {item.name}
                    </li>
                  ))}
                </ul>
              </div>
              {/* 循环表 */}
              <div className="CurrentTag">
                {this.state.newLoading ? (
                  <Loading />
                ) : (
                  <ListView
                    key={`lv${this.state.Tagid}`}
                    ref={(el) => (this[`lv${this.state.Tagid}`] = el)}
                    dataSource={this.state.dataSource}
                    initialListSize={12}
                    renderFooter={() =>
                      this.state.isLoading ? (
                        <div className="footer">
                          {this.state.isHasMore ? "加载中..." : "暂无更多数据"}
                        </div>
                      ) : (
                        ""
                      )
                    }
                    renderRow={row}
                    onEndReachedThreshold={10}
                    onEndReached={this.onEndReached.bind(this)}
                    scrollRenderAheadDistance={500}
                    onScroll={(e) => this.changgeScrollTop(e)}
                    style={{
                      height: "96%",
                      overflow: "auto",
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {this.state.showModal ? (
          <Modal
            view={true}
            showModal={this.state.showModal}
            groupData={this.state.selectData.storeGroupEntity}
            detailId={this.state.detailId}
            close={() => {
              this.close();
            }}
          />
        ) : (
          ""
        )}
      </div>
    );
  }
}
export default withRouter(Mainstructure);
